"use client";

import type { RefObject } from "react";
import { BackArrowIcon } from "./paletteIcons";

/** Search Input Bar for the command list and the run-worker picker. */
export function PaletteSearchHeader({
  viewMode,
  search,
  inputId,
  inputRef,
  onSearchChange,
  onClear,
  onBack,
}: {
  viewMode: "root" | "run-worker";
  search: string;
  inputId: string;
  inputRef: RefObject<HTMLInputElement | null>;
  onSearchChange: (value: string) => void;
  onClear: () => void;
  onBack: () => void;
}) {
  return (
    <header className="flex items-center gap-3 border-b border-zinc-800 px-4 py-3.5">
      {viewMode === "run-worker" ? (
        <button
          type="button"
          onClick={() => onBack()}
          className="rounded p-1 text-zinc-400 hover:bg-zinc-800 hover:text-zinc-200"
          title="Back"
        >
          <BackArrowIcon />
        </button>
      ) : (
        <svg
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden
          className="size-5 shrink-0 text-zinc-400"
        >
          <circle cx="7" cy="7" r="4.5" stroke="currentColor" strokeWidth="1.3" />
          <path
            d="M10.5 10.5 14 14"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        </svg>
      )}

      <input
        ref={inputRef}
        id={inputId}
        type="text"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={
          viewMode === "run-worker"
            ? "Type worker name to run..."
            : "Type a command or search workers..."
        }
        className="w-full bg-transparent text-sm text-zinc-100 placeholder:text-zinc-500 outline-none"
        autoComplete="off"
        spellCheck={false}
      />

      {search && (
        <button
          type="button"
          onClick={() => onClear()}
          className="rounded px-1.5 py-0.5 text-xs text-zinc-500 hover:text-zinc-300"
        >
          Clear
        </button>
      )}

      <kbd className="hidden shrink-0 rounded border border-zinc-800 bg-zinc-900 px-1.5 py-0.5 text-[10px] font-medium text-zinc-400 sm:inline-block">
        ESC
      </kbd>
    </header>
  );
}
